<app-lista-categoria
  titulo="Eventos"
  color="#9c29df"
  [items]="items"
  [contador]="eventos.length"
  [cargando]="cargando"
  textoVacio="Sin eventos detectados"
  (verEnMapa)="verEnMapa($event)"
>
  <!-- Filtro por título: propio de los eventos, que vienen de categorías muy
       distintas entre sí -->
  @if (titulosDisponibles.length > 1) {
    <div class="categorias-filter">
      <div class="categorias-header">
        <mat-icon class="categorias-icon">filter_alt</mat-icon>
        <span class="categorias-label">Filtrar</span>
        <button
          irxBotonIcono
          tamano="compacto"
          class="toggle-all-btn"
          (click)="toggleTodasCategorias()"
          [tooltip]="
            titulosSeleccionados.size === titulosDisponibles.length
              ? 'Deseleccionar todos'
              : 'Seleccionar todos'
          "
        >
          <mat-icon>
            {{
              titulosSeleccionados.size === titulosDisponibles.length
                ? 'deselect'
                : 'select_all'
            }}
          </mat-icon>
        </button>
      </div>
      <div class="categorias-chips">
        @for (titulo of titulosDisponibles; track titulo) {
          <button
            class="irx-chip irx-chip--compacto"
            [attr.aria-pressed]="titulosSeleccionados.has(titulo)"
            (click)="toggleTitulo(titulo)"
          >
            {{ titulo }}
          </button>
        }
      </div>
      @if (items.length !== eventos.length) {
        <span class="categorias-count">
          Mostrando {{ items.length }} de {{ eventos.length }}
        </span>
      }
    </div>
  }
</app-lista-categoria>
